module.exports = __webpack_public_path__ + "media/fonts/bootstrap-icons-dfd0ea12.woff2";